module.exports = {
    content: [
		//'./**/*.php', // recursive search for *.php (be aware on every file change it will go even through /node_modules which can be slow, read doc)
		//'./src/styles/safelist.txt' // Use in case the inline "safelist" gets too long
		'./*.php',
		'./lib/**/*.php',
		'./templates/**/*.php',
		'./search-filter/**/*.php',
	],
	safelist: [
		'scroll-lock',
		//{
			//pattern: /text-(white|black)-(200|500|800)/
		//}
	],
    theme: {
        colors: {
			'transparent': 'transparent',
            'white': '#FFF',
            'black': '#000',
			'grey': '#ECECEC',
			'grey-2': '#C6C6C5',
			'navy': '#064891',
			'blue-1': '#1F63AD',
			'blue-2': '#94C4F0',
			'blue-3': '#C9E8FF',
			'coral-1': '#FA5E61',
			'coral-2': '#FF9EA1',
			'coral-3': '#FFCCCF',
			'teal-1': '#008F8A',
			'teal-2': '#70CCC7',
			'teal-3': '#A1D9D6',
			'yellow-1': '#ED7000',
			'yellow-2': '#FFBA3B',
			'yellow-3': '#FFDEA3',
			'green-1': '#59A34A',
			'green-2': '#9CD991',
			'green-3': '#C2E8BF',
			'purple-1': '#948CD4',
			'purple-2': '#C9ADE8',
			'purple-3': '#E0D1F2',
        },
        fontFamily: {
            figtree: ['Figtree', 'sans-serif'],
            national: ['"National 2 Condensed"', 'sans-serif'],
        },
        /* fontSize: {
            '30': ['30px'],
            '48': ['48px'],
        }, */
		/* lineHeight: {
            '30': '30px',
            '40': '40px',
        }, */
		/* letterSpacing: {
            tighter: '-0.5px',
            tight: '-0.25px',
            normal: 'normal',
            wide: '-0.1px',
            wider: '-0.07px',
            widest: '1px',
        }, */
		borderRadius: {
			'none': '0px',
			2: '2px',
			4: '4px',
			5: '5px',
			6: '6px',
			8: '8px',
			10: '10px',
			12: '12px',
			14: '14px',
			15: '15px',
			20: '20px',
			25: '25px',
			30: '30px',
			35: '35px',
			40: '40px',
			45: '45px',
			50: '50px',
			100: '100px',
			full: '9999px',
		},
		spacing: {
			0: "0px",
			1: "1px",
			2: "2px",
			3: "3px",
			4: "4px",
			5: "5px",
			6: "6px",
			7: "7px",
			8: "8px",
			9: "9px",
			10: "10px",
			12: "12px",
			15: "15px",
			18: "18px",
			16: "16px",
			20: "20px",
			24: "24px",
			25: "25px",
			28: "28px",
			30: "30px",
			35: "35px",
			40: "40px",
			45: "45px",
			50: "50px",
			55: "55px",
			60: "60px",
			65: "65px",
			70: "70px",
			75: "75px",
			80: "80px",
			85: "85px",
			90: "90px",
			95: "95px",
			100: "100px",
			105: "105px",
			110: "110px",
			115: "115px",
			120: "120px",
			125: "125px",
			130: "130px",
			135: "135px",
			140: "140px",
			145: "145px",
			150: "150px",
			160: "160px",
			170: "170px",
			180: "180px",
			190: "190px",
			200: "200px",
			210: "210px",
			220: "220px",
			240: "240px",
			250: "250px",
			270: "270px",
			280: "280px",
			290: "290px",
			300: "300px",
			350: "350px",
			400: "400px",
			420: "420px",
			450: "450px",
			480: "480px",
			500: "500px",
		},
        container: {
			center: true,
			padding: {
				// Need to assign all of the screen sizes or the container-break-out plugin won't work
				DEFAULT: '30px',
				xs: '40px',
				sm: '40px',
				md: '40px',
				lg: '40px',
				xl: '40px',
				'2xl': '40px',
			},
			screens: {
				xs: '340px',
				sm: '576px',
				md: '768px',
				lg: '992px',
				xl: '1280px',
				'2xl': '1536px',
			},
		},
		screens: {
			xs: '340px',
			sm: '576px',
			md: '768px',
			lg: '992px',
			xl: '1280px',
			'2xl': '1536px',
		},
        extend: {
			container: {
				screens: {
					xs: {
						max: 'none', // Remove the max-width: 340px from the xs breakpoint
					},
				},
			},
            typography: (theme) => ({
                DEFAULT: {
                    css: {
                        '*': {
                            '&:first-child': {
                                marginTop: 0,
                            },
                            '&:last-child:not(img):not(picture)': {
                                marginBottom: 0,
                            },
                            '&:last-child:not(img):not(picture) img': {
                                marginBottom: 0,
                            }
                        },
                    },
                },
            }),
			debugScreens: {
				position: ['top', 'right'],
			},
			zIndex: {
				1: '1',
				2: '2',
				3: '3',
				4: '4',
				5: '5',
				100: '100',
			},
			backgroundImage: {
				'download': "url('../img/icons/download.svg')",
				'download--white': "url('../img/icons/download--white.svg')",
				'search': "url('../img/icons/search--blue-circle.svg')",
				'external-link': "url('../img/icons/external-link.svg')",
			}
        }
    },
    plugins: [
        function ({ addVariant }) {
			addVariant('letterbox', '@media screen and (min-width: 992px) and (max-height: 750px)');
            addVariant("children", "& > *");
            addVariant("children-all", "& *");
            //addVariant("next-peer-hover", ".peer:hover + &");
            //addVariant("item-active", "&[data-active=true]");
            //addVariant("item-active-children", "&[data-active=true] > *");
        },
        require('@tailwindcss/typography'),
		require('@tailwindcss/forms'),
		require('tailwindcss-debug-screens'),
		require('tailwind-container-break-out')
    ],
}